<template>
    <div class="our-call-center-view" data-sectionThemeDark="true">
        <return-menu  />
        <!-- <responsive-burger-menu   v-bind:MenuItems="MenuItems" /> -->
        <!-- home page view , each <section> must be a layout component -->
        <landing-intro-secondary v-bind:LandingIntroData="LandingIntroData" />    
        
        <section class="executive-summary section" data-sectionThemeDark="false">
            <div class="summary-container">
                <br>
                <h2 class="section-heading --tert">Our Finance Team</h2>
                <p class="content-text"></p>
                
            </div>
            <div class="scroll-indicator-container">
            </div>
        </section>  

        <OurStars v-bind:OurStarsList="OurStarsList"/>
        <contact-us v-bind="ContactUsData" />
        <FooterLayout />
    </div>
</template>

<script>
import ReturnMenu from '@/components/ui/ReturnMenu'
// import ResponsiveBurgerMenu from '@/components/ui/ResponsiveBurgerMenu'
import LandingIntroSecondary from '@/components/layout/LandingIntroSecondary'
import OurStars from '@/components/layout/OurStars'
import ContactUs from '@/components/layout/ContactUs'
import FooterLayout from '@/components/layout/Footer'
import FinanceStarsJson from '@/assets/FinanceStars.json';


export default {
    components: { ReturnMenu, LandingIntroSecondary, OurStars, ContactUs, FooterLayout },
    data() {
        return {
            LandingIntroData: {
                NameLocation: '#Home',
                BackgroundClass: '--finance-visual',
                HeadingText: '“Providing Insights, strategies, and financial oversight needed to drive growth and stability. By managing budgets, forecasting, and insuring fiscal responsibility, Finance empowers the company to make informed decisions, navigate challenges, and unlock new oppertunities for success. ”',
                Speaker: null,
                Btn: '#keepingYouSafe',
                BtnState: false,
                ShowVideo: false
            },
            OurStarsList: FinanceStarsJson,
            ContactUsData: [{
                NameLocation: 'ContactUs',
                items: ['Client Service', 'Finance', 'Resolutions', 'Procurement', 'Medical Desk']
            }],
        };
    },
    mounted: function() {
        console.log(this.OurStarsList);
    },
    methods: {}
};
</script>

<style lang="scss">
.our-call-center-view {
    @media screen and (max-width: 480px) {
        .executive-summary {
            margin-top: -200px;
            margin-bottom: -300px;
        }
    }
}

</style>
